import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';

const AcceptedDeviceDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation</DialogTitle>
     
      <DialogContent> Accepting these devices will add them to the organization’s device network. These devices can be later removed from the devices section. Are you sure you want to accept all the above-mentioned devices? </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">Cancel</Button>
        <Button onClick={onConfirm} color="success">
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptedDeviceDialog;
